export default __webpack_public_path__ + "locales/bg/InfoPanel.json?hash=3104fc48d19ba763edb1d4eb4577b489";